import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FileSearch from '../../components/files/FileSearch.jsx';

import {
  retrieveFiles,
  searchFiles,
  selectFileSearchQuery,
  updateFileSearchQuery,
} from '../../modules/files.js';

const mapStateToProps = (state) =>
  createSelector(selectFileSearchQuery(), (query) => ({ query }))(state);

const mapDispatchToProps = {
  searchFiles,
  retrieveFiles,
  updateFileSearchQuery,
  selectFileSearchQuery,
};

class ProjectFilesSearchContainer extends React.PureComponent {
  handleSearch = (event) => {
    const {
      projectId,
      initiativeType,
      initiativeId,
      searchFiles,
      retrieveFiles,
      updateFileSearchQuery,
    } = this.props;

    const query = event.target.value;

    updateFileSearchQuery(query);

    if (query.length === 0) {
      // Retrieve all files when query is blank
      retrieveFiles(projectId, initiativeType, initiativeId);
    } else {
      searchFiles(projectId, query, initiativeType, initiativeId);
    }
  };

  render() {
    const {
      query,
      count,
      projectId,
      initiativeProjectId,
      initiative,
      project,
      navigateToNewFile,
    } = this.props;

    return (
      <FileSearch
        count={count}
        handleSearch={this.handleSearch}
        query={query}
        projectId={projectId}
        project={project}
        initiativeProjectId={initiativeProjectId}
        initiative={initiative}
        navigateToNewFile={navigateToNewFile}
      />
    );
  }
}

ProjectFilesSearchContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectFilesSearchContainer);

export default ProjectFilesSearchContainer;
